import { OdinIcon, OdinIconSize } from '@myosh/odin-components';

const DataCellLoading = () => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <OdinIcon icon="RefreshCw" spin={true} size={OdinIconSize.ExtraSmall} />
    </div>
  );
};

export default DataCellLoading;
